import { toast } from 'react-toastify';
import { decodeJwtPayload } from './authToken';
import { logoutLisualWidget } from './useLisualWidget';

let navigateFunction = null;

export const setAuthRedirect = (navigate) => {
  navigateFunction = navigate;
};

export const logoutAndRedirect = () => {
  localStorage.removeItem('authLisualToken');
  logoutLisualWidget();
  toast.error('La sesión ha terminado, por favor iniciar nuevamente.', {
    toastId: 'session-expired', // Evita duplicados
  });
  if (navigateFunction) {
    navigateFunction('/', { replace: true });
  } else {
    window.location.href = '/';
  }
};

export const isTokenExpired = (token) => {
  if (!token) return true;
  const payload = decodeJwtPayload(token);
  if (!payload || !payload.exp) return true;

  const currentTime = Date.now() / 1000;
  return payload.exp < currentTime;
};

export const getTokenRemainingTime = (token) => {
  if (!token) return 0;
  const payload = decodeJwtPayload(token);
  if (!payload || !payload.exp) return 0;

  const currentTime = Date.now() / 1000;
  return Math.max(0, payload.exp - currentTime); // Tiempo restante en segundos
};
